import { NavigationActions } from 'react-navigation'
import { RESET } from '../redux/game'

// Actions
export const ADD_GLOBAL_ERROR = 'ascension/error/add'
// Reducer
const initialState = {
  error: null,
  notRetryable: false
}

const reducer = (state = initialState, action = {}) => {
  switch (action.type) {
    case ADD_GLOBAL_ERROR: {
      return {
        ...state,
        error: action.data.message,
        notRetryable: action.data.notRetryable || false
      }
    }
    case RESET: {
      return initialState
    }
    default: return state
  }
}

export default reducer

// Action Creators

export function addError ({ message, notRetryable }) {
  return {
    type: ADD_GLOBAL_ERROR,
    data: { message, notRetryable }
  }
}

export function addGlobalError (navigation, { message, notRetryable }, navigator) {
  return async (dispatch) => {
    dispatch(addError({ message, notRetryable }))
    if (navigation) {
      navigation.navigate('Error')
    }
    if (navigator) {
      navigator.dispatch(
        NavigationActions.navigate({
          routeName: 'Error',
          params: {}
        })
      )
    }
  }
}
